import { useEffect, useState } from 'react';
import { useParams, useNavigate, Link } from 'react-router-dom';
import { ref, get } from 'firebase/database';
import { db } from '../lib/firebase.js';
import Assessment from './Assessment.jsx';

// AdminAssessment — staff-administered assessment.
// Loads the specified resident's account, then renders the
// Assessment component in staff mode. On completion, the
// Assessment component navigates back to the resident roster
// with a results summary.
export default function AdminAssessment() {
  const { residentId } = useParams();
  const navigate = useNavigate();
  const [account, setAccount] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    let cancelled = false;
    (async () => {
      try {
        const snap = await get(ref(db, `brain_health/accounts/${residentId}`));
        if (cancelled) return;
        const val = snap.val();
        if (!val) {
          setError('Resident not found.');
          return;
        }
        setAccount({ id: residentId, ...val });
      } catch (err) {
        if (!cancelled) setError(err.message);
      }
    })();
    return () => { cancelled = true; };
  }, [residentId]);

  if (error) {
    return (
      <div className="container assessment">
        <div className="assessment-error" role="alert">
          <p className="assessment-error-line">{error}</p>
          <Link to="/admin/communities" className="btn btn-secondary">
            ← Back to communities
          </Link>
        </div>
      </div>
    );
  }

  if (!account) {
    return (
      <div className="container assessment">
        <p className="assessment-meta">Loading resident…</p>
      </div>
    );
  }

  return <Assessment mode="staff" residentOverride={account} />;
}
